import { motion } from 'framer-motion';

export const SignatureStatement = () => {
  return (
    <section
      className="relative bg-[linear-gradient(180deg,#F7F6F2_0%,#FFFFFF_55%,#FAF8F2_100%)] py-20 lg:py-28 overflow-hidden"
      data-testid="signature-statement-section"
    >
      {/* Subtle gold corner glyphs for editorial framing */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            'radial-gradient(circle at 15% 25%, #D4AF37 0%, transparent 35%), radial-gradient(circle at 85% 75%, #0B2240 0%, transparent 40%)',
        }}
      />

      <div className="relative mx-auto max-w-3xl px-6 sm:px-8 lg:px-10">
        {/* Eyebrow */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          className="flex items-center justify-center lg:justify-start gap-3 mb-8"
          data-testid="signature-eyebrow"
        >
          <span className="h-px w-8 bg-[#D4AF37]" />
          <span className="font-['Inter'] text-[11px] font-semibold tracking-[0.22em] uppercase text-[#D4AF37]">
            The KGOB Standard
          </span>
          <span className="h-px w-8 bg-[#D4AF37] lg:hidden" />
        </motion.div>

        {/* Oversized opening quote glyph */}
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, delay: 0.1 }}
          aria-hidden="true"
          className="font-['Playfair_Display'] text-[#D4AF37]/70 text-7xl sm:text-8xl leading-none select-none text-center lg:text-left -mb-4 lg:-mb-6 lg:-ml-2"
        >
          &ldquo;
        </motion.div>

        {/* Main statement — upright, deliberate */}
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="font-['Playfair_Display'] font-medium text-[1.65rem] sm:text-[2rem] lg:text-[2.35rem] leading-[1.35] tracking-[-0.005em] text-[#0B2240] text-center lg:text-left"
          data-testid="signature-statement-body"
        >
          At KGOB, we believe excellence is earned quietly — in every detail, every decision, every conversation. Our clients and colleagues don&rsquo;t just work with us
          <span className="text-[#0B2240]/60">.</span>
        </motion.p>

        {/* Hairline gold rule before the punchline */}
        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="origin-center lg:origin-left mt-8 mb-6 mx-auto lg:mx-0 h-px w-16 bg-[#D4AF37]"
          data-testid="signature-divider"
        />

        {/* Punchline — italic, slightly smaller, the moment of emphasis */}
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, delay: 0.65 }}
          className="font-['Playfair_Display'] italic font-semibold text-[1.45rem] sm:text-[1.65rem] lg:text-[1.85rem] leading-snug text-[#0B2240] text-center lg:text-left"
          data-testid="signature-statement-punchline"
        >
          They grow with us.
        </motion.p>

        {/* Attribution */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5, delay: 0.85 }}
          className="mt-8 flex items-center justify-center lg:justify-start gap-3"
          data-testid="signature-attribution"
        >
          <span className="font-['Inter'] text-[11px] font-medium tracking-[0.2em] uppercase text-[#0B2240]/50">
            Kohari Gonzalez Oneyear &amp; Brown
          </span>
        </motion.div>
      </div>
    </section>
  );
};
